import { FC } from 'react';
import { IconButton } from '@chakra-ui/react';

import { ReactComponent as ContextVertIcon } from 'resources/images/context-vertical.svg';
import { ContextMenuOption } from 'types/general.types';
import { ListItemAction } from '../ListItemAction';
import { BodyRow } from '../types';
import { ContextMenuProps } from '../ContextMenu/types';

interface ContextMenuButtonProps {
  row: BodyRow;
  contextMenuProps: ContextMenuProps;
}

export const ContextMenuButton: FC<ContextMenuButtonProps> = ({
  row,
  contextMenuProps,
}) => {
  const { setPosition, setOptions } = contextMenuProps;
  const options = ((row?.rowData as BodyRow)?.options ||
    []) as ContextMenuOption[];
  const shouldRenderButton = options.length > 0;

  if (!shouldRenderButton) {
    return null;
  }

  return (
    <ListItemAction>
      <IconButton
        className="options"
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={(e) => {
          setOptions(options);
          const {
            x,
            y,
            width,
          } = (e.target as HTMLElement)?.getBoundingClientRect();
          setPosition({ x: x + width, y: y + 20 });
        }}
        data-testid="kebab-menu-button"
        size="large"
        variant="text"
        sx={{ path: { fill: 'iconBase' } }}
        ml={2}
        border="none"
      >
        <ContextVertIcon />
      </IconButton>
    </ListItemAction>
  );
};
